<template>
  <div>
    <b-sidebar class="d-block d-lg-flex" id="sidebar">
      <template>
        <div class="sidebar-geral">
          <div class="col-12 d-flex mr-2 justify-content-end mt-2">
            <button @click="closeSidebar" class="btn btn-outline-secondary" style="border: none;
              position: fixed;
              margin-right: -35px;
              margin-bottom: -32px;
              margin-top: -10px;
              font-size: 16px;
              background-image: linear-gradient(45deg, #177174, #6cbf65);
              z-index: 999999;
              color: #fff;">
              <span id="spanIconSidebar"> ☰ </span> </button>
          </div>
          <div class="col-12 pt-3 row sidebar-header">
            <div class="col-3 sidebar-img-user">
              <img class="fotoColab" :src="fotoColaborador" alt="" width="55" style="border-radius: 50px;">
            </div>
            <div class="col-9" id="divColaborador">
              <div class="col-12">
                <p class="nomeColaborador">{{ dsColaborador }}</p>
              </div>
              <div class="col-12">
                <p>{{ filialName }}</p>
              </div>
            </div>


            <div class="col-12 mt-2 divAmbiente">
              <button class="btn btnAmbiente" @click="mudarAmbiente('M')" :style="classMecanica"><i class="fa fa-wrench"
                  aria-hidden="true" style="font-size: 23px"></i></button>
              <button class="btn btnAmbiente" @click="mudarAmbiente('P')" :style="classPneu"> <img
                  src="../../assets/wheel.png" width="30"> </button>
            </div>

          </div>

          <hr>

          <div class="sidebar-content" v-if="tipoAmbiente">
            <b-nav-item v-if="!fornecExt" to="/novaOs" :active="[ 'novaOs', '' ].includes($route.name)"
              class="mr-2 bg-light">
              <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" height="1em"
                viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                <path
                  d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
              </svg>
              {{ $t('Nova OS Proativa') }}
            </b-nav-item>

            <b-nav-item to="/execucao" class="mt-3 mr-2  mt-lg-0 bg-light"
              :active="[ 'ItensExecucao' ].includes($route.name)">
              <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" height="1em"
                viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                <path
                  d="M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
              </svg>
              <span class="badge mr-4" :class="false ? 'badge-secondary' : 'badge-warning'">
                {{ parseFloat(emExecucao) + parseFloat(countExecucaoPreventiva) }}
              </span>
              {{ $t('Execuções') }}
            </b-nav-item>

            <b-nav-item v-if="!fornecExt" to="/osReabertas" :active="[ 'osReabertas' ].includes($route.name)"
              class="mr-2 bg-light">
              <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" height="1em"
                viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                <path
                  d="M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z" />
              </svg>
              <span class="badge mr-4" :class="false ? 'badge-secondary' : 'badge-warning'">
                {{ osReabertas }}
              </span>{{ $t('Reaberta') }}</b-nav-item>

            <b-nav-item v-if="!fornecExt && !mecanico " to="/historico" class="mt-3 mr-2  mt-lg-0 bg-light"
              :active="[ 'historico' ].includes($route.name)">
              <i class="fas fa-user" :style="'margin-right: 3.6rem!important'"></i> Meus Atendimentos
            </b-nav-item>

            <p class="subMenus d-none">{{ $t('Dashboard') }}</p>

            <b-nav-item v-if="!fornecExt" to="/dashboard" :active="[ 'Dashboard' ].includes($route.name)" class="mr-2 bg-light " >
              <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" viewBox="0 0 512 512" height="1.2em">
                <path d="M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm128-64l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zM480 96l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32s32 14.3 32 32z"/></svg>
              <span class="badge mr-4" :class="false ? 'badge-secondary' : 'badge-warning'">
                
              </span> {{ $t('DashBoard') }}
            </b-nav-item>

            <div v-if="perfilCaminhao">

              <p class="subMenus">{{ $t('Frota') }}</p>

              <b-nav-item v-if="!fornecExt" to="/" :active="[ 'Home' ].includes($route.name)" class="mr-2 bg-light">
                <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" height="1em"
                  viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                  <path
                    d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" />
                </svg>
                <span class="badge mr-4" :class="false ? 'badge-secondary' : 'badge-warning'">
                  {{ osInterna }}
                </span> {{ $t('Interno') }}
              </b-nav-item>
              <b-nav-item v-if="mecanico || fornecExt || mecanicoExterno" to="/osExterna"
                :active="[ 'osExterna' ].includes($route.name)" class="mr-2 bg-light">
                <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" height="1em"
                  viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                  <path
                    d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z" />
                </svg>
                <span class="badge mr-4" :class="false ? 'badge-secondary' : 'badge-warning'">
                  {{ osExterna }}
                </span>{{ $t('Externo') }}</b-nav-item>

              <b-nav-item to="/osPreventiva" :active="[ 'osPreventiva' ].includes($route.name)" class="mr-2 bg-light">
                <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" height="1em"
                  viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                  <path
                    d="M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z" />
                </svg>
                <span class="badge mr-4" :class="false ? 'badge-secondary' : 'badge-warning'">
                  {{ osPreventiva }}
                </span>{{ $t('Preventiva') }}</b-nav-item>

              <b-nav-item to="/osPreditiva" :active="[ 'osPreditiva' ].includes($route.name)" class="mr-2 bg-light btnComprido" >
                <i class="fa fa-truck mr-2" aria-hidden="true"></i>
                <span class="badge mr-4" :class="false ? 'badge-secondary' : 'badge-warning'" >
                  {{ osPreditiva }}
                </span>{{ $t('Preventiva Programada') }}</b-nav-item>




              <b-nav-item class="d-block d-md-none mt-3 bg-light" @click="logout">
                <i class="fas fa-sign-out-alt"></i> {{ $t('Sair') }}
              </b-nav-item>
              <hr>
            </div>

            <div v-if="perfilArmazem">
              <p class="subMenus">{{ $t('Armazém') }}</p>
              <!-- <p class="subMenus" v-if="mecanico || fornecExt">{{ $t('Armazém') }}</p> -->
              <b-nav-item v-if="!fornecExt" to="/osEmpilhadeira" class="mr-2 bg-light"
                :active="[ 'osEmpilhadeira' ].includes($route.name)">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-forklift mr-2" width="24"
                  height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <circle cx="5" cy="17" r="2" />
                  <circle cx="14" cy="17" r="2" />
                  <line x1="7" y1="17" x2="12" y2="17" />
                  <path d="M3 17v-6h13v6" />
                  <path d="M5 11v-4h4" />
                  <path d="M9 11v-6h4l3 6" />
                  <path d="M22 15h-3v-10" />
                  <line x1="16" y1="13" x2="19" y2="13" />
                </svg>
                <span v-if="!fornecExt" class="badge mr-4" :class="false ? 'badge-secondary' : 'badge-warning'">
                  {{ osArmazem }}
                </span>{{ $t('Armazém') }}</b-nav-item>
              <b-nav-item v-if="mecanico || fornecExt || mecanicoExterno" to="/osExternaArmazem" class="mr-2 bg-light"
                :active="[ 'osExternaArmazem' ].includes($route.name)">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-forklift mr-2" width="24"
                  height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <circle cx="5" cy="17" r="2" />
                  <circle cx="14" cy="17" r="2" />
                  <line x1="7" y1="17" x2="12" y2="17" />
                  <path d="M3 17v-6h13v6" />
                  <path d="M5 11v-4h4" />
                  <path d="M9 11v-6h4l3 6" />
                  <path d="M22 15h-3v-10" />
                  <line x1="16" y1="13" x2="19" y2="13" />
                </svg>
                <svg class="mr-2 btn-preventiva-armazem" :style="fornecExt ? 'margin-right: 3.3rem!important' : false"
                  xmlns="http://www.w3.org/2000/svg" height="1em"
                  viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                  <path
                    d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z" />
                </svg>
                <span class="badge mr-4" :class="false ? 'badge-secondary' : 'badge-warning'">
                  {{ osArmazemExterna }}
                </span>{{ $t('Externas Armazém') }}</b-nav-item>
              <b-nav-item to="/osPreventivaArmazem" class="mr-2 bg-light"
                :active="[ 'osPreventivaArmazem' ].includes($route.name)">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-forklift mr-2" width="24"
                  height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <circle cx="5" cy="17" r="2" />
                  <circle cx="14" cy="17" r="2" />
                  <line x1="7" y1="17" x2="12" y2="17" />
                  <path d="M3 17v-6h13v6" />
                  <path d="M5 11v-4h4" />
                  <path d="M9 11v-6h4l3 6" />
                  <path d="M22 15h-3v-10" />
                  <line x1="16" y1="13" x2="19" y2="13" />
                </svg>
                <svg class="mr-2 btn-preventiva-armazem" :style="fornecExt ? '' : false"
                  xmlns="http://www.w3.org/2000/svg" height="1em"
                  viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                  <path
                    d="M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z" />
                </svg>
                <span class="badge mr-4" :class="false ? 'badge-secondary' : 'badge-warning'">
                  {{ osArmazemPreventiva }}
                </span>{{ $t('Preventivas Armazém') }}</b-nav-item>
              <b-nav-item to="/osPredivitaArmazem" class="mr-2 bg-light"
                :active="[ 'osPredivitaArmazem' ].includes($route.name)">
                <i class="fa fa-truck mr-2" aria-hidden="true"></i>
                <span class="badge mr-4" :class="false ? 'badge-secondary' : 'badge-warning'">
                  {{ osArmazemPreditiva }}
                </span>{{ $t('Preventiva Programada Armazém') }}</b-nav-item>

              <b-nav-item v-if="validaMercosul" to="/desbloqueiaEmpilhadeira" class="mr-2 bg-light" :active="[ 'desbloqueiaEmpilhadeira' ].includes($route.name)">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-forklift mr-2" width="24"
                  height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <circle cx="5" cy="17" r="2" />
                  <circle cx="14" cy="17" r="2" />
                  <line x1="7" y1="17" x2="12" y2="17" />
                  <path d="M3 17v-6h13v6" />
                  <path d="M5 11v-4h4" />
                  <path d="M9 11v-6h4l3 6" />
                  <path d="M22 15h-3v-10" />
                  <line x1="16" y1="13" x2="19" y2="13" />
                </svg>
                <svg class="mr-2 btn-preventiva-armazem" :style="fornecExt ? '' : false"
                  xmlns="http://www.w3.org/2000/svg" height="1em"
                  viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                  <path
                    d="M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z" />
                </svg>
                <span class="badge mr-4" :class="false ? 'badge-secondary' : 'badge-warning'">
                </span>{{ $t('Desbloqueia Empilhadeira') }}
              </b-nav-item>

              <hr>
            </div>
            <div>
              <p class="subMenus" v-if="!fornecExt">{{ $t('Outros') }}</p>

              <b-nav-item v-if="exibe_os_encerrada" @click="$bvModal.show('modalEncerradas');" class="mr-2 bg-light">
                <i class="fa fa-file-excel" aria-hidden="true" :style="'margin-right: 3.6rem!important'"></i>
                {{ $t('Ver Encerradas') }}</b-nav-item>

              <b-nav-item v-if="!fornecExt && permissaoInventario" to="/inventario" class="bg-light"
                :active="[ 'inventario' ].includes($route.name)">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-box-seam" width="24"
                  height="24" style="margin-right: 50px!important;" viewBox="0 0 24 24" stroke="currentColor"
                  stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 3l8 4.5v9l-8 4.5l-8 -4.5v-9l8 -4.5" />
                  <path d="M12 12l8 -4.5" />
                  <path d="M8.2 9.8l7.6 -4.6" />
                  <path d="M12 12v9" />
                  <path d="M12 12l-8 -4.5" />
                </svg>
                {{ $t('Inventário') }}</b-nav-item>
              <b-nav-item href="https://web.whatsapp.com/send?phone=554991698966" target="_blank" class="bg-light">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                  class="icon icon-tabler icon-tabler-box-seam" style="margin-right: 50px!important;"
                  viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                  <path
                    d="M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
                </svg>
                {{ $t('Tem dúvida?') }}</b-nav-item>
            </div>
          </div>

          <div class="sidebar-content" v-if="!tipoAmbiente">
            <p class="subMenus">{{ $t('Borracharia') }}</p>

            <b-nav-item v-if="!fornecExt" to="/borracharia/" :active="[ 'indexBorracharia' ].includes($route.name)"
              class="mr-2 bg-light">
              <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" height="1em"
                viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                <path
                  d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" />
              </svg>
              {{ $t('DashBoard') }}
            </b-nav-item>

            <b-nav-item v-if="!fornecExt" to="/borracharia/afericao" :active="[ 'afericao' ].includes($route.name)"
              class="mr-2 bg-light">
              <img src="../../assets/wheel.png" width="22" style="margin-right: 8px">
              {{ $t('Aferição') }}
            </b-nav-item>

            <b-nav-item v-if="!fornecExt" to="/borracharia/movimentacao"
              :active="[ 'movimentacao' ].includes($route.name)" class="mr-2 bg-light">
              <i class="fa fa-share" aria-hidden="true" style="margin-right: 8px"></i>
              {{ $t('Movimentação/Troca') }}
            </b-nav-item>

            <b-nav-item v-if="!fornecExt" to="/borracharia/descarte" :active="[ 'descarte' ].includes($route.name)"
              class="mr-2 bg-light">
              <i class="fa fa-recycle" aria-hidden="true" style="margin-right: 8px"></i>
              {{ $t('Descarte') }}
            </b-nav-item>

            <b-nav-item v-if="!fornecExt" to="/borracharia/servico" :active="[ 'servico' ].includes($route.name)"
              class="mr-2 bg-light">
              <i class="fa fa-cog" aria-hidden="true" style="margin-right: 8px"></i>
              {{ $t('Serviço') }}
            </b-nav-item>
          </div>

          <div class="col-12 row footerLanguage">
            <img class="p-1 imgFooterLanguage" @click="alteraIdioma('pt')" src="@/assets/brasil.png"
              alt="bandeira_brasil" width="40">
            <img class="p-1 imgFooterLanguage" @click="alteraIdioma('es')" src="@/assets/mercosul.png"
              alt="bandeira_brasil" width="40">
          </div>

        </div>
      </template>
    </b-sidebar>
    <modal-encerradas></modal-encerradas>
    <loadAmbiente></loadAmbiente>
  </div>
</template>

<script>
import ModalEncerradas from '../Modais/ModalEncerradas.vue'
import loadAmbiente from '../loadAmbiente.vue'

export default {
  data() {
    return {
      fornecedorExterno: false,
      classPneu: '',
      classMecanica: '',
      tipoAmbiente: true
    }
  },
  computed: {
    // tipoAmbiente() {
    //   const filial = this.$store.getters['filial/filial']
    // },
    validaMercosul() {
      const filial = this.$store.getters['filial/filial']

      if(filial.location == 'M') {
        return true
      }

      return false
    }, 

    exibe_os_encerrada() {
      try {
        const encerradas = this.$store.getters['filial/filial']

        if (encerradas.exibe_os_encerrada == true) {
          return true
        } else {
          return false
        }
      } catch (error) {
        return true
      }
    },

    permissaoInventario() {
      try {
        const tipoPerfil = this.$store.getters['filial/filial']

        if (tipoPerfil.st_inventario === 'S' || !tipoPerfil.st_inventario) {
          return true
        } else {

          return false
        }
      } catch (error) {
        return true
      }
    },

    perfilCaminhao() {
      try {
        const tipoPerfil = this.$store.getters['filial/filial']

        if (tipoPerfil.tipoPerfilTerminal == 'C' || tipoPerfil.tipoPerfilTerminal == 'T' && tipoPerfil.tipoPerfilTerminal != null) {
          if (tipoPerfil.perfilMecanico === 'C' || !tipoPerfil.perfilMecanico) {
            return true
          } else {
            return false
          }
        }

        return false
      } catch (error) {
        return true
      }
    },

    perfilArmazem() {
      try {
        const tipoPerfil = this.$store.getters['filial/filial']
        if (tipoPerfil.tipoPerfilTerminal == 'E' || tipoPerfil.tipoPerfilTerminal == 'T') {

          if (tipoPerfil.perfilMecanico === 'E' || !tipoPerfil.perfilMecanico) {
            return true
          } else {
            return false
          }
        }

        return false
      } catch (error) {
        return true
      }
    },
    filialName() {
      const filial = this.$store.getters['filial/filial']

      if (filial) {
        return filial.ds_filial
      }

      return null
    },
    fotoColaborador() {
      const fotoColaborador = this.$store.getters['filial/filial']

      return 'https://ginfo.inovess.com.br/cadastros/colab/arquivoscolab/' + fotoColaborador.foto
    }, 
    dsColaborador() {
      const dsColaborador = this.$store.getters['filial/filial']

      return dsColaborador.dsColaborador.substring(0, 10)
    },
    totalReabertas() {
      return this.$store.getters['os/totalReabertas']
    },
    fornecExt() {
      const mecanica = JSON.parse(localStorage.filial);
      if (mecanica.fornecExt === 'S') {
        return true
      } else {
        return false
      } 
    },

    countExecucaoPreventiva() {
      return this.$store.getters['osItemExecucao/totalIniciadasPreventivas']
    },

    mecanico() {
      let mecanicoOs = JSON.parse(localStorage.filial);


      if (mecanicoOs.atendeOs == 'S') {
        return false
      } else {
        return true
      }
    },

    mecanicoExterno() {
      try {
        let mecanicoOs = JSON.parse(localStorage.filial);

        if (mecanicoOs.mecanico_externo) {
          return true
        } else {
          return false
        }
      } catch (error) {
        return false
      }
    },

    avalFornecedorExterno() {
      const fornecExterno = this.$store.getters['colaborador/findMecanico']

      if (fornecExterno == null) {
        return false
      }

      return true
    },

    items() {
      return this.$store.getters['os/page'](this.paginacao.currentPage)
    },

    paginacao() {
      return this.$store.getters['os/pagination']
    },
    emExecucao() {
      if (!this.$store.getters['osItemExecucao/iniciadas']) {
        this.$store.dispatch('osItemExecucao/fetchIniciadasFromApi')
        return 0
      }

      return this.$store.getters['osItemExecucao/totalIniciadas']
    },
    osInterna() {
      return this.$store.getters['osItemExecucao/totalInternas']
    },

    osExterna() {
      return this.$store.getters['osItemExecucao/totalExternas']
    },

    osPreventiva() {
      return this.$store.getters['osItemExecucao/totalPreventivas']
    },

    osPreditiva() {
      return this.$store.getters['osItemExecucao/totalPreditiva']
    },

    osReabertas() {
      return this.$store.getters['osItemExecucao/totalReabertas']
    },
    osArmazem() {
      return this.$store.getters['osItemExecucao/totalArmazem']
    },
    osArmazemExterna() {
      return this.$store.getters['osItemExecucao/totalArmazemExterna']
    },
    osArmazemPreventiva() {
      return this.$store.getters['osItemExecucao/totalArmazemPreventiva']
    },
    osArmazemPreditiva() {
      return this.$store.getters['osItemExecucao/totalArmazemPreditiva']
    },
    osEmpilhadeira() {
      return true
    },

    placasBorracharia() {
      return 10
    }
  },

  mounted() {
    this.$store.dispatch('osItemExecucao/fetchArmazemExternaFromApi')
  },

  created() {
    this.$store.dispatch('osItemExecucao/fetchInternasFromApi')
    this.$store.dispatch('osItemExecucao/fetchExternasFromApi')
    this.$store.dispatch('osItemExecucao/fetchReabertasFromApi')
    this.$store.dispatch('osItemExecucao/fetchArmazemFromApi')
    // this.$store.dispatch('osItemExecucao/fetchArmazemExternaFromApi')
    this.$store.dispatch('osItemExecucao/fetchPreditivasFromApi')
    this.$store.dispatch('osItemExecucao/fetchPreditivasFromApiArmazem')
    console.log('Testee')
    const filial = JSON.parse(localStorage.filial)
    const link = window.location.href

    if (link.includes('borracharia')) {
      this.btnAmbiente('P')
      // this.mudarAmbiente('P')
      this.tipoAmbiente = false 

    } else {
      this.btnAmbiente('M')
      // this.mudarAmbiente('M')
      this.tipoAmbiente = true

    }

    let filters = {
      placa: '',
      tipo: 'V',
      de: '',
      ate: '',
      codigo: '',
      atendeOs: ''
    }
    if (filial.atendeOs == "S") {
      filters.atendeOs = 'S'
    }

    this.$store.commit('osItemExecucao/setFilters', { filters: filters })
    this.$store.dispatch('osItemExecucao/fetchPreventivasFromApi')
    this.$store.dispatch('osItemExecucao/fetchArmazemPreventivasFromApi')

    const fornecExt = this.$store.getters['filial/filial']
    this.$store.dispatch('colaborador/findMecanico', { idMecanico: fornecExt.tecnicoId })

  },

  methods: {
    btnAmbiente(tipoAmbiente) {
      const filial = this.$store.getters['filial/filial']

      if (filial.ambiente == null) {
        this.$store.dispatch('filial/setLocalStorageFilial', { data: 'M' })
      }

      if (tipoAmbiente == 'M') {
        this.classMecanica = 'border: 3px solid #177174!important;'
        this.classPneu = ''
      }
      if (tipoAmbiente == 'P') {
        this.classMecanica = ''
        this.classPneu = 'border: 3px solid #177174!important;'
      }
    },

    loadAmbiente(tipoAmbiente) {
      const divAmbiente = document.getElementById('loadAmbiente')
      divAmbiente.style.height = window.screen.height + 'px'
      divAmbiente.style.width = window.screen.width + 'px'

      const divLoaderPneu = document.getElementById('containerLoaderPneu')
      divLoaderPneu.classList.add('activeLoadAmbiente')

      const divColaborador = document.getElementById('divColaborador')
      divColaborador.style.display = 'none'

      const iconLoad = document.getElementById('imgLoaderPneu')

      if (tipoAmbiente == 'M') {
        iconLoad.classList.add('chaveLoad')
        iconLoad.classList.remove('wheelsLoad')
      } else if (tipoAmbiente == 'P') {
        iconLoad.classList.remove('chaveLoad')
        iconLoad.classList.add('wheelsLoad')
      }

      setTimeout(() => {
        divLoaderPneu.classList.remove('activeLoadAmbiente')

        setTimeout(() => {
          divAmbiente.style.width = '0px'
        }, 500)

        if (tipoAmbiente == 'M') {
          this.$router.push('/')
        } else if (tipoAmbiente == 'P') {
          this.$router.push('/borracharia')
        }
      }, 1000)
    },

    mudarAmbiente(tipoAmbiente) {
      this.$store.dispatch('filial/setLocalStorageFilial', { data: tipoAmbiente })
      this.btnAmbiente(tipoAmbiente)
      this.loadAmbiente(tipoAmbiente)


    },


    alteraIdioma(lang) {
      const idiomaSelecionado = {
        lang: lang
      }
      localStorage.lang = JSON.stringify(idiomaSelecionado)
      window.location.reload()
    },
    closeSidebar() {

      this.$store.dispatch('filial/actionSidebar')

      // const sidebar = document.getElementById('sidebar')
      // const iconSidebar = document.getElementById('spanIconSidebar')
      // const content = document.getElementById('layout-top-nav')
      // const divColaborador = document.getElementById('divColaborador')
      // const widthSidebar = document.getElementById('sidebar').offsetWidth

      // const isMobile = window.screen.width;

      // if (isMobile <= 991) {
      //   if (widthSidebar == '0') {
      //     sidebar.style.width = '300px'
      //     iconSidebar.textContent = 'X',
      //       divColaborador.style.display = 'block'
      //   } else {
      //     sidebar.style.width = '0px'
      //     iconSidebar.textContent = '☰'
      //     divColaborador.style.display = 'none'
      //   }
      // } else {
      //   if (widthSidebar == '95') {
      //     console.log('95px')
      //     sidebar.style.width = '300px'
      //     content.style.marginLeft = '300px'
      //     iconSidebar.textContent = 'X'
      //     divColaborador.style.display = 'block'
      //   } else {
      //     console.log('ELSE')

      //     sidebar.style.width = '95px'
      //     content.style.marginLeft = '95px'
      //     iconSidebar.textContent = '☰'
      //     divColaborador.style.display = 'none'
      //   }
      // }
    },
    findMecanico() {
      const fornecExt = this.$store.getters['filial/filial']

      this.$store.dispatch('colaborador/findMecanico', { idMecanico: fornecExt.tecnicoId }).then(response => {
        if (response.data.colaborador.nr_seq_fornecedor_externo == null) {
          this.fornecedorExterno = false
        } else {
          this.fornecedorExterno = true
        }
      })
    },
    logout() {
      this.$store.dispatch('filial/logout')
    },

    fetchItemsFromApi() {
      this.$store.dispatch('os/fetchFromApi')
    }
  },
  components: {
    ModalEncerradas,
    loadAmbiente
  }
}
</script>

<style src="./style.css" scoped />
